import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ projectId, elementType, elementId, documents }) =>
    present(
      repository
        .attachDocumentsToElement(projectId, elementType, elementId, documents)
        .then(({ documents }) => ({
          projectId,
          elementId,
          documents,
          elementType,
        }))
        .catch(() =>
          Promise.reject({ projectId, elementId, documents: [], elementType }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
